<template>
  <div class="app-container">
    <div class="page-title" style="display:flex;flex-direction:row">
      <h2>{{ $t('structure.structures') }}</h2>
      <h2>🏢</h2>
    </div>
    <el-row :gutter="40" class="panel-group">
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <h1>🏢</h1>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">
              Total Campagne Agricole
            </div>
            <count-to :start-val="0" :end-val="list.length" :duration="2600" class="card-panel-num" />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-card v-if="checkRole(['admin'])" class="box-card filter-card just-for-admin">
      <div slot="header" class="clearfix">
        <span>{{ $t('general.filter') }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="initSearch">{{ $t('general.init') }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio v-model="activeList" label="desactives" border @change="getSubStructuresList('indexdesactive')">{{ $t('general.F_desactives') }}</el-radio>
        <el-radio v-model="activeList" label="disponibles" border @change="handleFilterStructures">{{ $t('general.disponibles') }}</el-radio>
        <el-radio v-model="activeList" label="corbeille" class="danger-radio" border @change="getSubStructuresList('indexinvisible')">{{ $t('general.corbeille') }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input v-model="query.keyword" :placeholder="$t('general.keyword')" class="wd-200 mr-15 filter-item" @keyup.enter.native="handleFilterStructures" />
        <el-button v-waves class="mr-15 filter-item" type="primary" icon="el-icon-search" @click="handleFilterStructures">
          {{ $t('general.search') }}
        </el-button>
        <el-button v-waves :loading="downloading" class="filter-item" type="primary" icon="el-icon-download" @click="handleDownload">
          {{ $t('general.export') }}
        </el-button>
        <el-button v-if="checkPermission(['creer structure'])" class="mr-15 filter-item" type="primary" icon="el-icon-plus" @click="handlecreateStructure">
          {{ $t('general.add') }}
        </el-button>
        <el-button v-if="checkPermission(['creer structure'])" class="mr-15 filter-item" type="primary" icon="el-icon-plus" @click="drawer=true">
          Importer
        </el-button>
      </div>
      <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">
        <!-- el-table-column align="center" label="Code" min-width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column -->

        <el-table-column align="center" :label="$t('general.nom')" min-width="200px">
          <template slot-scope="scope">
            <span>{{ scope.row.nom }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('general.description')" min-width="250px">
          <template slot-scope="scope">
            <span>{{ scope.row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="checkPermission(['activer structure'])" align="center" :label="$t('general.status')" width="100">
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              @change="setStructureStatus(scope.row.id,'active')"
            />
          </template>
        </el-table-column>

        <el-table-column v-if="checkRole(['admin']) && (activeList=='corbeille' || query.keyword)" align="center" :label="$t('general.restaurer')" width="100">
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setStructureStatus(scope.row.id,'visible')"
            />
          </template>
        </el-table-column>

        <el-table-column v-if="checkPermission(['modifier structure','visible structure','supprimer structure'])" align="center" :label="1==1 ? $t('general.actions') : $t('general.suppressionDefinitive')" width="200">
          <template slot-scope="scope">
            <el-button v-if="scope.row.is_visible && checkPermission(['modifier structure'])" type="primary" size="small" icon="el-icon-edit" style="margin-right:10px;" @click="handleEditStructure(scope.row.id);" />
            <el-button v-if="checkPermission(['visible structure','supprimer structure'])" slot="reference" type="danger" size="small" icon="el-icon-delete" style="margin-right:10px;" @click="handleDeleteStructure(scope.row.id, scope.row.is_visible, scope.row.nom);" />
            <el-button type="info" size="small" icon="el-icon-view" @click="showDetailsPage(scope.row.id)" />
          </template>
        </el-table-column>
      </el-table>

      <pagination v-if="total > query.limit" :total="total" :page.sync="query.page" :limit.sync="query.limit" @pagination="getStructuresList" />

      <!-- ======= REGION USER DIALOG ======= -->
      <el-dialog
        :title="editing ? $t('structure.edit') + ' ' + currentStructure.nom : $t('structure.AddStructure')"
        :visible.sync="dialogCreateStructure"
        :before-close="handleCloseCampagneagricoleCreateDraw"
        :loading="structureCreating"
        width="30%"
      >
        <div class="content-inputs">
          <el-form ref="structureForm" :rules="rules" :model="currentStructure" label-position="left">
            <el-form-item :label="$t('structure.nom')" prop="nom">
              <el-input v-model="currentStructure.nom" />
            </el-form-item>
            <el-form-item :label="$t('general.description')" prop="description">
              <el-input v-model="currentStructure.description" type="textarea" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:right;">
            <el-button plain type="danger" @click="dialogCreateStructure=false">
              {{ $t('permission.cancel') }}
            </el-button>
            <el-button type="primary" :loading="structureCreating" @click="editing ? updateStructure() : createStructure()">
              {{ structureCreating ? $t('general.saving') : $t('general.save') }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <el-dialog
        title="Importation"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        width="60%"
      >
        <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
        <el-table :data="tableData" border highlight-current-row style="width: 100%;margin-top:20px;">
          <el-table-column v-for="item of tableHeader" :key="item" :prop="item" :label="item" />
        </el-table>
        <el-button type="success" :disabled="!tableData.length>0" @click="bulkInsert">Insérer</el-button>
      </el-dialog>

      <!-- ======= REGION USER DIALOG ======= -->

    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
import CountTo from 'vue-count-to';
const bulkstructureResource = new Resource('structures_import');
import UploadExcelComponent from '@/components/UploadExcel/index.vue';
const structureResource = new Resource('structures');
export default {
  name: 'StructuresList',
  // components: {  },
  components: { UploadExcelComponent, Pagination, CountTo },
  directives: { waves, permission, role },
  data() {
    return {
      tableData: [],
      tableHeader: [],
      drawer: false,
      list: null,
      total: 0,
      loading: true,
      downloading: false,
      activeList: 'disponibles',
      structureCreating: false,
      editing: false,
      currentStructure: {},
      query: {
        page: 1,
        limit: 100,
        keyword: '',
      },
      dialogCreateStructure: false,
      currentStructureId: 0,
      rules: {
        nom: [{ required: true, message: this.$t('structure.NomRequired'), trigger: 'blur' }],
      },
      fileList: [],
    };
  },
  computed: {

  },
  created() {
    this.resetNewStructure();
    this.getStructuresList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array){
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseCampagneagricoleCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    cancelstructureForm() {
      this.$refs.CampagneagricoleCreationDrawer.closeDrawer();
    },
    async setStructureStatus(id, type){
      const data = await structureResource.get('toogle_' + type + '/' + id);
      if (data.success){
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    bulkInsert(){
      console.log('LES ENTETES : ', this.tableHeader);
      var validHeaders = this.tableHeader.length === 2 && this.tableHeader[0] === 'nom' && this.tableHeader[1] === 'description';
      if (validHeaders) {
        console.log('DATA : ', this.tableData);
        const data = { 'structures': this.tableData };
        bulkstructureResource
          .store(data)
          .then(async(response) => {
            this.$message({
              message: this.$t('structure.NewStructure') + this.$t('structure.iscreatedSuccessfully'),
              type: 'success',
              duration: 5 * 1000,
            });
            // this.currentProduitId = response.data.id;
            this.resetNewStructure();
            this.dialogCreateStructure = false;
            this.handleFilterStructures();
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.structureCreating = false;
            this.drawer = false;
            this.tableHeader = [];
            this.tableData = [];
          });
        // for (let index = 0; index < this.tableData.length; index++) {
        //   const element = this.tableData[index];
        //   console.log('A INSERER : ', element);
        //   if (element.nom !== '') {
        //     structureResource
        //       .store(element)
        //       .then(async(response) => {
        //         console.log('index ', index, response.data);
        //       })
        //       .catch(error => {
        //         console.log(error);
        //       })
        //       .finally(() => {
        //         this.drawer = false;
        //         this.tableHeader = [];
        //         this.tableData = [];
        //       });
        //   }
        // }
        console.log('ENTETES VALIDE');
      } else {
        this.$message({
          message: 'DONNEES NON CONFORMES',
          type: 'info',
          duration: 5 * 1000,
        });
      }
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning',
      });
      return false;
    },
    handleSuccess({ results, header }) {
      this.tableData = results;
      this.tableHeader = header;
    },
    initSearch(){
      this.handleFilterStructures();
    },
    showDetailsPage(id){
      this.$router.push({ path: '/structure/' + id });
    },
    async getStructuresList() {
      this.loading = true;
      const { data, meta } = await structureResource.list(this.query);
      this.list = data.reverse();
      this.total = meta !== undefined ? meta.total : 0;
      console.log('===== EDI');
      console.log(data);
      console.log('===== EVO');
      this.loading = false;
    },
    async getSubStructuresList(subUrl) {
      this.loading = true;
      const { data } = await structureResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterStructures() {
      this.query.page = 1;
      this.getStructuresList();
    },
    handlecreateStructure() {
      this.editing = false;
      this.resetNewStructure();
      this.dialogCreateStructure = true;
      this.$nextTick(() => {
        this.$refs['structureForm'].clearValidate();
      });
    },
    handleEditStructure(id){
      this.editing = true;
      this.resetNewStructure();
      this.currentStructure = this.list.find(abonne => abonne.id === id);
      this.dialogCreateStructure = true;
      this.$nextTick(() => {
        this.$refs['structureForm'].clearValidate();
      });
    },
    handleDeleteStructure(id, visible, nom) {
      console.log('id : ' + id + 'nom : ' + nom);
      this.$confirm(this.$t('structure.deleteWarn') + ' ' + nom + '. ' + this.$t('general.deleteContinue'), 'Warning', {
        confirmButtonText: 'Oui',
        cancelButtonText: this.$t('general.cancel'),
        type: 'warning',
      }).then(() => {
        console.log('result : ');
        if (!visible && (checkRole(['admin']) || checkPermission(['supprimer structure']))) {
          console.log('result 2 : ');
          this.$swal({
            title: this.$t('general.SureQuestion'),
            text: this.$t('general.irrversibleMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('general.ouiSupprimer'),
          }).then((result) => {
            if (result.isConfirmed) {
              structureResource.destroy(id).then(response => {
                this.$message({
                  type: 'success',
                  message: this.$t('structure.suppressionEffectue'),
                });
                this.initSearch();
              }).catch(error => {
                console.log(error);
              });
            }
          });
        } else {
          this.setStructureStatus(id, 'visible');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('general.suppressionAnnule'),
        });
      });
    },
    createStructure() {
      this.$refs['structureForm'].validate((valid) => {
        if (valid) {
          this.structureCreating = true;
          structureResource
            .store(this.currentStructure)
            .then(async(response) => {
              this.$message({
                message: this.$t('structure.NewStructure') + ' ' + this.currentStructure.nom + ' ' + this.$t('structure.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentStructureId = response.data.id;
              this.resetNewStructure();
              this.dialogCreateStructure = false;
              this.handleFilterStructures();
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.structureCreating = false;
            });
        } else {
          console.log('Erreur !!');
          return false;
        }
      });
    },
    updateStructure() {
      this.$refs['structureForm'].validate((valid) => {
        if (valid) {
          this.structureCreating = true;
          structureResource.update(this.currentStructure.id, this.currentStructure).then(response => {
            this.resetNewStructure();
            this.handleFilterStructures();
            this.$message({
              message: this.$t('structure.isupdatedSuccessfully'),
              type: 'success',
              duration: 5 * 1000,
            });
            this.dialogCreateStructure = false;
            this.editing = false;
          })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.structureCreating = false;
            });
        } else {
          console.log('Erreur !!');
          return false;
        }
      });
    },
    resetNewStructure() {
      this.currentStructure = {
        nom: '',
        description: '',
      };
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['ID', this.$t('structure.nom'), this.$t('general.description')];
        const filterVal = ['id', 'nom', 'description'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Liste des structures SCIAGRI_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    onChange(file, fileList){
      var a = this.fileList;
      a.push({ name: file.name, url: file.url });
      // console.log('onChange begin');
      this.fileList = a;
      // console.log(this.fileList);
      // console.log('onChange end');
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
